let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("83Dnz")).then(() => parcelRequire('1e8Au'));